var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UsersList',{attrs:{"users":_vm.superAdminUsers,"is-loading-list":_vm.isLoadingList},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('CIcon',{attrs:{"name":"cil-people"}}),_vm._v(" Admin Users "),_c('CButton',{staticClass:"float-right",attrs:{"size":"sm","color":"info"},on:{"click":function($event){return _vm.$router.push({
            name: 'SuperAdminUserCreate',
            exact: true
          })}}},[_c('CIcon',{attrs:{"size":"sm","name":"cil-plus"}}),_vm._v(" Create New ")],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }